import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../reducers/authReducer';
import kidReducer from '../reducers/kidReducer';
import loadingReducer from '../reducers/loadingReducer';

const store = configureStore({
  reducer: {
    auth: authReducer,
    kid: kidReducer,
    loading: loadingReducer,
  },
});

export default store;